import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/flowStep/importer/flowStepImporterSelectors';
import FlowStepService from 'src/modules/flowStep/flowStepService';
import fields from 'src/modules/flowStep/importer/flowStepImporterFields';
import { i18n } from 'src/i18n';

const flowStepImporterActions = importerActions(
  'FLOWSTEP_IMPORTER',
  selectors,
  FlowStepService.import,
  fields,
  i18n('entities.flowStep.importer.fileName'),
);

export default flowStepImporterActions;